<template>
    <div class="mainBody">
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="car_type" label="车型" sortable="custom"></el-table-column>
                <el-table-column prop="banben" label="版本" sortable="custom"></el-table-column>
                <el-table-column prop="day_count" label="天数" sortable="custom">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.day_count" placeholder="请输入预计交付天数" style="width: 100px" @blur="onBlur($event, scope.row.id)"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import { setDayCount } from '@/api/delivery'

export default {
    name: 'deliveryDayConfigList',
    mixins: [listutil],
    data() {
        return {
            m_name: '交付时间配置',
            menu_id: 3500,
            list_url: "/api/admin/deliverydayconfig/list",
            search_Obj: {
                f_xxxname: '',
            },
            del_Obj:{
                url:'/api/admin/deliverydayconfig/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {
        onBlur(e, id){
            let set_value = e.target.value
            let data = {
                "id": id, 
                "day_count": set_value
            }
            setDayCount(data).then(res=>{
                if(res.code===1){
                    this.$msgs("保存成功！");
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>